import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AppAuthService } from '../../../cores/auth/app-auth-service';
import { Store } from '@ngrx/store';
import {
  ConnectionStatus,
  openSidebar,
  selectGlobalRulesConnectionStatus,
  selectGlobalRulesIsHealthCheckPassed,
  selectGlobalRulesPosUiVersion,
} from '../../../stores/global';
import { NavigationEnd, Router } from '@angular/router';
import { ElectronService } from '../../../services/electron.service';
import { SyncBacklogIndicatorComponent } from '../sync-backlog-indicator/sync-backlog-indicator.component';
import { PriceFreshnessService } from '../../../services/price-freshness.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule,
    TranslateModule,
    SyncBacklogIndicatorComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnDestroy {
  isHealthCheckPassed: Observable<boolean>;
  connectionStatus: Observable<ConnectionStatus>;
  posUiVersion: Observable<string>;
  showSideBarButtonVisible = false;
  readonly showSyncBacklog: boolean;

  private destroy$ = new Subject<void>();
  private priceFreshnessPoll?: Subscription;

  constructor(
    private authService: AppAuthService,
    private store: Store,
    private router: Router,
    private cdr: ChangeDetectorRef,
    electronService: ElectronService,
    priceFreshness: PriceFreshnessService,
  ) {
    this.showSyncBacklog = electronService.isElectron;
    if (this.showSyncBacklog) {
      // Keeps the 24 h / 72 h price warnings and the discount block fed; the label lives in Settings.
      this.priceFreshnessPoll = priceFreshness.start();
    }
    this.isHealthCheckPassed = this.store.select(selectGlobalRulesIsHealthCheckPassed);
    this.connectionStatus = this.store.select(selectGlobalRulesConnectionStatus);
    this.posUiVersion =this.store.select(selectGlobalRulesPosUiVersion);
    this.updateSidebarButtonVisibility(this.router.url);

    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.updateSidebarButtonVisibility(event.urlAfterRedirects);
        }
      });
  }

  ngOnDestroy() {
    this.priceFreshnessPoll?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  showSideBarClicked() {
    this.store.dispatch(openSidebar());
  }

  private updateSidebarButtonVisibility(url: string) {
    this.showSideBarButtonVisible =
      this.authService.isLoggedIn() && !url.startsWith('/login');
    this.cdr.markForCheck();
  }
}
